import React from 'react';
import PropTypes from 'prop-types';
import DesktopMenuItem from '../desktop-menu-item/DesktopMenuItem';
import FlyoutMenu from '../flyout-menu/FlyoutMenu';
import styles from './DesktopMenu.scss';

const DesktopMenu = ({ child }) => {
  const filteredChild = child?.filter(
    item => item.isDisplayedInGlobalNav !== false
  );

  return (
    <nav className={styles.desktopMenu} data-testid="desktop-navigation-menu">
      <ul className={styles.desktopMenuList}>
        {filteredChild.map(item => {
          const { name, url, child: childItems } = item;
          return (
            <DesktopMenuItem
              key={name}
              label={name}
              url={url}
              className={styles.desktopMenuItem}
            >
              {childItems?.length > 0 && (
                <FlyoutMenu columns={childItems} topLevelTitle={name} />
              )}
            </DesktopMenuItem>
          );
        })}
      </ul>
      <div className={styles.desktopMenuOverlay} />
    </nav>
  );
};

const itemShape = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
itemShape.child = PropTypes.arrayOf(PropTypes.shape(itemShape));

DesktopMenu.propTypes = {
  child: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
};

export default DesktopMenu;
